import firebase from "../firebase";

export default function({ officeId, visitId, name, lastName }) {
    const data = { officeId, visitId, name, lastName };

    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "patientTrackingUser",
        funcName: "updatePatientName",
        data: data
    });
}
